import { useState } from 'react';
import Modal from '../../../templates/Modal';
import useUserMediaAccessState, { UserMediaAccessStateEnum } from 'utils/useUserWebcamAccessState';
import { LoadWrapper } from 'components/class/psa/style';
import { IconLoading } from 'components/common/icons';
import { ContentWrapper, InsideModal, ModalActions, PermissionModalButton } from './styles';

export const PermissionModal = () => {
  const { devicePermission, permissionError, loading, isAccessAllowed } = useUserMediaAccessState();
  const [hideModal, setHideModal] = useState(false);

  let title = '';
  let content = null;

  if (!loading && devicePermission.camera === false) {
    title = 'Camera permission denied';
    content = (
      <ul>
        <li>Please allow access to your camera to join the video call.</li>
        <li>After giving permission please reload the page</li>
      </ul>
    );
  }

  if (!loading && devicePermission.microphone === false) {
    title = 'Microphone permission denied';
    content = (
      <ul>
        <li>Please allow access to your microphone to join the video call.</li>
        <li>After giving permission please reload the page</li>
      </ul>
    );
  }

  if (!loading && permissionError?.name === 'NotFoundError') {
    title = 'No camera or microphone found';
    content = (
      <p>
        Please make sure your camera and microphone are connected and not in use by another
        application.
      </p>
    );
  }

  if (
    !loading &&
    (permissionError?.name === 'NotReadableError' || permissionError?.name === 'AbortError')
  ) {
    title = "We can't use your camera";
    content = (
      <div>
        <ul style={{ display: 'flex', flexDirection: 'column', gap: '.5rem' }}>
          <li>Make sure there are no other applications using your camera</li>
          <li>
            If you&apos;re using an external camera or microphone, try disconnecting and
            reconnecting it
          </li>
          <li>Try closing and reopening your browser</li>
          <li>Try using another browser</li>
        </ul>
      </div>
    );
  }

  if (!loading && permissionError?.name === 'OverconstrainedError') {
    title = 'Oops something went wrong';
    content = (
      <div>
        <p>It seems that the camera or microphone is not working properly.</p>
        <p>Please try reloading the page</p>
      </div>
    );
  }

  const handleAskUserForPermission = async () => {
    try {
      await navigator.mediaDevices.getUserMedia({ video: true, audio: true });

      setHideModal(true);
    } catch (error) {
      if (error.name === 'NotAllowedError') {
        alert(
          'Please allow access to your camera and microphone. You can do this in your browser settings.'
        );
      } else {
        window.location.reload();
      }
    }
  };

  if (loading) {
    return (
      <LoadWrapper>
        <IconLoading />
      </LoadWrapper>
    );
  }

  return (
    <Modal
      title={title}
      content={
        <InsideModal>
          <ContentWrapper>{content}</ContentWrapper>
          <ModalActions>
            <PermissionModalButton variant="primary" onClick={handleAskUserForPermission}>
              Try Again
            </PermissionModalButton>
            <PermissionModalButton variant="secondary" onClick={() => setHideModal(true)}>
              Dismiss
            </PermissionModalButton>
          </ModalActions>
        </InsideModal>
      }
      footer={{}}
      close={() => setHideModal(true)}
      isOpen={isAccessAllowed === UserMediaAccessStateEnum.rejected && !hideModal}
    />
  );
};

